module.exports = __webpack_public_path__ + "static/media/playstore.52dfdab7.png";